/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsightfulnessCriterion } from './InsightfulnessCriterion';
import {
  InsightfulnessCriterionFromJSON,
  InsightfulnessCriterionFromJSONTyped,
  InsightfulnessCriterionToJSON,
} from './InsightfulnessCriterion';
import type { PerformanceMetric } from './PerformanceMetric';
import {
  PerformanceMetricFromJSON,
  PerformanceMetricFromJSONTyped,
  PerformanceMetricToJSON,
} from './PerformanceMetric';
import type { QuestionnaireAssessment } from './QuestionnaireAssessment';
import {
  QuestionnaireAssessmentFromJSON,
  QuestionnaireAssessmentFromJSONTyped,
  QuestionnaireAssessmentToJSON,
} from './QuestionnaireAssessment';
import type { AiModel } from './AiModel';
import { AiModelFromJSON, AiModelFromJSONTyped, AiModelToJSON } from './AiModel';
import type { ModelTypeEnum } from './ModelTypeEnum';
import { ModelTypeEnumFromJSON, ModelTypeEnumFromJSONTyped, ModelTypeEnumToJSON } from './ModelTypeEnum';
import type { StyleCriterion } from './StyleCriterion';
import { StyleCriterionFromJSON, StyleCriterionFromJSONTyped, StyleCriterionToJSON } from './StyleCriterion';
import type { ProtectedGroupDataset } from './ProtectedGroupDataset';
import {
  ProtectedGroupDatasetFromJSON,
  ProtectedGroupDatasetFromJSONTyped,
  ProtectedGroupDatasetToJSON,
} from './ProtectedGroupDataset';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';
import type { DatasetPipelineShallow } from './DatasetPipelineShallow';
import {
  DatasetPipelineShallowFromJSON,
  DatasetPipelineShallowFromJSONTyped,
  DatasetPipelineShallowToJSON,
} from './DatasetPipelineShallow';
import type { PersonalDataExposureCategory } from './PersonalDataExposureCategory';
import {
  PersonalDataExposureCategoryFromJSON,
  PersonalDataExposureCategoryFromJSONTyped,
  PersonalDataExposureCategoryToJSON,
} from './PersonalDataExposureCategory';
import type { ReportType } from './ReportType';
import { ReportTypeFromJSON, ReportTypeFromJSONTyped, ReportTypeToJSON } from './ReportType';

/**
 *
 * @export
 * @interface AssessmentQuestionnaireAnswer
 */
export interface AssessmentQuestionnaireAnswer {
  /**
   *
   * @type {number}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly id: number;
  /**
   *
   * @type {AiModel}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly aiModel: AiModel;
  /**
   *
   * @type {DatasetPipelineShallow}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly datasetPipeline: DatasetPipelineShallow;
  /**
   *
   * @type {Array<RiskMetric>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly selectedRiskMetrics: Array<RiskMetric>;
  /**
   *
   * @type {Array<StyleCriterion>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly styleCriteria: Array<StyleCriterion>;
  /**
   *
   * @type {ModelTypeEnum}
   * @memberof AssessmentQuestionnaireAnswer
   */
  modelType?: ModelTypeEnum | null;
  /**
   *
   * @type {ProtectedGroupDataset}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly protectedGroupDataset: ProtectedGroupDataset;
  /**
   *
   * @type {Array<PerformanceMetric>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly performanceMetrics: Array<PerformanceMetric>;
  /**
   *
   * @type {ReportType}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly reportType: ReportType;
  /**
   *
   * @type {Array<InsightfulnessCriterion>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly insightfulnessCriteria: Array<InsightfulnessCriterion>;
  /**
   *
   * @type {Array<PersonalDataExposureCategory>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly personalDataExposureCategories: Array<PersonalDataExposureCategory>;
  /**
   *
   * @type {string}
   * @memberof AssessmentQuestionnaireAnswer
   */
  user?: string;
  /**
   *
   * @type {Date}
   * @memberof AssessmentQuestionnaireAnswer
   */
  timestamp?: Date;
  /**
   *
   * @type {Array<QuestionnaireAssessment>}
   * @memberof AssessmentQuestionnaireAnswer
   */
  readonly assessments: Array<QuestionnaireAssessment>;
}

/**
 * Check if a given object implements the AssessmentQuestionnaireAnswer interface.
 */
export function instanceOfAssessmentQuestionnaireAnswer(value: object): value is AssessmentQuestionnaireAnswer {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('datasetPipeline' in value) || value['datasetPipeline'] === undefined) return false;
  if (!('selectedRiskMetrics' in value) || value['selectedRiskMetrics'] === undefined) return false;
  if (!('styleCriteria' in value) || value['styleCriteria'] === undefined) return false;
  if (!('protectedGroupDataset' in value) || value['protectedGroupDataset'] === undefined) return false;
  if (!('performanceMetrics' in value) || value['performanceMetrics'] === undefined) return false;
  if (!('reportType' in value) || value['reportType'] === undefined) return false;
  if (!('insightfulnessCriteria' in value) || value['insightfulnessCriteria'] === undefined) return false;
  if (!('personalDataExposureCategories' in value) || value['personalDataExposureCategories'] === undefined)
    return false;
  if (!('assessments' in value) || value['assessments'] === undefined) return false;
  return true;
}

export function AssessmentQuestionnaireAnswerFromJSON(json: any): AssessmentQuestionnaireAnswer {
  return AssessmentQuestionnaireAnswerFromJSONTyped(json, false);
}

export function AssessmentQuestionnaireAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AssessmentQuestionnaireAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: AiModelFromJSON(json['ai_model']),
    datasetPipeline: DatasetPipelineShallowFromJSON(json['dataset_pipeline']),
    selectedRiskMetrics: (json['selected_risk_metrics'] as Array<any>).map(RiskMetricFromJSON),
    styleCriteria: (json['style_criteria'] as Array<any>).map(StyleCriterionFromJSON),
    modelType: json['model_type'] == null ? undefined : ModelTypeEnumFromJSON(json['model_type']),
    protectedGroupDataset: ProtectedGroupDatasetFromJSON(json['protected_group_dataset']),
    performanceMetrics: (json['performance_metrics'] as Array<any>).map(PerformanceMetricFromJSON),
    reportType: ReportTypeFromJSON(json['report_type']),
    insightfulnessCriteria: (json['insightfulness_criteria'] as Array<any>).map(InsightfulnessCriterionFromJSON),
    personalDataExposureCategories: (json['personal_data_exposure_categories'] as Array<any>).map(
      PersonalDataExposureCategoryFromJSON,
    ),
    user: json['user'] == null ? undefined : json['user'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assessments: (json['assessments'] as Array<any>).map(QuestionnaireAssessmentFromJSON),
  };
}

export function AssessmentQuestionnaireAnswerToJSON(
  value?: Omit<
    AssessmentQuestionnaireAnswer,
    | 'id'
    | 'aiModel'
    | 'datasetPipeline'
    | 'selectedRiskMetrics'
    | 'styleCriteria'
    | 'protectedGroupDataset'
    | 'performanceMetrics'
    | 'reportType'
    | 'insightfulnessCriteria'
    | 'personalDataExposureCategories'
    | 'assessments'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    model_type: ModelTypeEnumToJSON(value['modelType']),
    user: value['user'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
  };
}
